import React from 'react';

import { ImageIcon } from '@mssgme/icons';

import styles from './Thumbnail.scss';

export default function Thumbnail() {
    return <ImageIcon className={styles.root} />;
}
